import * as stylex from "@stylexjs/stylex";
import { layout } from "../materials/layout.stylex";
/**
 * This component can be used to force content to display in a specific ratio.
 * This is useful in cases where 'vw' is not really what is needed. This fits
 * into it's parents width and scales accordingly while clipping the children to
 * fit. As it's filling the width, the `yOffset` can be used to adjust the content
 * vertically.
 *
 * Based on https://codesandbox.io/s/aspectratiodiv-mnbys
 */ export const AspectRatioContainer = ({ ratio = [
    1,
    1
], offsetY = 0, children })=>{
    const [w, h] = ratio;
    return <div className="x1n2onr6 xb3r6kr xh8yej3 xt7dq6l">
      <svg role="presentation" {...stylex.props(layout.fullWidth)} viewBox={`0 0 ${w} ${h}`}/>
      <div className="x10l6tqk x13vifvy xh8yej3 x5yr21d" style={{
        transform: `translateY(${offsetY}%)`
    }}>
        {children}
      </div>
    </div>;
};
